import { LoadsLifeAreas } from "@/types/lifeArea";
import { shuffleArray } from "@/utils/random";

type ScoredLifeArea = LoadsLifeAreas["life_areas"][number];

type ScoredLifeAreaOwner = LoadsLifeAreas & { id: number };

const TOP_SCORE = 2;

const MAX_LIFE_AREA_HIGHLIGHTS = 3;

const isCareerGrowth = (area: ScoredLifeArea) =>
    area.code_name === "career_growth";

export function getLifeAreaHighlights(
    coach: ScoredLifeAreaOwner,
    client: ScoredLifeAreaOwner,
): ScoredLifeArea[] {
    const clientScoreFor = (area: ScoredLifeArea) =>
        client.life_areas.find((clientArea) => clientArea.id === area.id)
            ?.score ?? 0;

    const coachLifeAreasInTieBreakOrder = shuffleArray(
        coach.life_areas,
        client.id * coach.id,
    );

    const clientTopGoal = coachLifeAreasInTieBreakOrder.find(
        (area) =>
            area.score > 0 &&
            clientScoreFor(area) === TOP_SCORE &&
            !isCareerGrowth(area),
    );

    const coachStrengths = coachLifeAreasInTieBreakOrder.filter(
        (area) => area.score === TOP_SCORE && area.id !== clientTopGoal?.id,
    );
    const strongMatches = coachStrengths.filter(
        (area) => clientScoreFor(area) === TOP_SCORE,
    );
    const secondaryStrongMatches = coachStrengths.filter(
        (area) => clientScoreFor(area) === 1,
    );

    const qualifyingAreas = [
        ...(clientTopGoal ? [clientTopGoal] : []),
        ...strongMatches,
        ...secondaryStrongMatches,
    ];
    const qualifyingAreasWithoutCareerGrowth = qualifyingAreas.filter(
        (area) => !isCareerGrowth(area),
    );

    return (
        qualifyingAreasWithoutCareerGrowth.length > 0
            ? qualifyingAreasWithoutCareerGrowth
            : qualifyingAreas
    ).slice(0, MAX_LIFE_AREA_HIGHLIGHTS);
}
